"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vehicle = void 0;
var Vehicle = /** @class */ (function () {
    function Vehicle(hw) {
        var _this = this;
        this.create = function (vehicleData, projectId) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = new URLSearchParams();
                if (projectId)
                    params.append("project_id", "" + projectId);
                return [2 /*return*/, this.highway.post("vehicle?" + params.toString(), vehicleData)];
            });
        }); };
        this.createMany = function (arrayServices, projectId) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = new URLSearchParams();
                if (projectId)
                    params.append("project_id", "" + projectId);
                return [2 /*return*/, this.highway.post("vehicles?" + params.toString(), arrayServices)];
            });
        }); };
        this.update = function (vehicleId, vehicle) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.highway.put("vehicle/" + vehicleId, vehicle)];
            });
        }); };
        this.delete = function (vehicleId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.highway.delete("vehicle/" + vehicleId)];
            });
        }); };
        this.get = function (vehicleID) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.highway.get("vehicle/" + vehicleID)];
            });
        }); };
        this.list = function (projectId, offset, limit, text, sort) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 20; }
            if (text === void 0) { text = undefined; }
            if (sort === void 0) { sort = undefined; }
            return __awaiter(_this, void 0, void 0, function () {
                var params;
                return __generator(this, function (_a) {
                    params = new URLSearchParams();
                    if (projectId) {
                        params.append("project_id", "" + projectId);
                    }
                    params.append("offset", "" + offset);
                    params.append("limit", "" + limit);
                    if (text) {
                        params.append("text", "" + text);
                    }
                    if (sort) {
                        params.append("sort", "" + sort);
                    }
                    return [2 /*return*/, this.highway.get("vehicles?" + params.toString())];
                });
            });
        };
        this.listFlat = function (projectId) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = new URLSearchParams();
                if (projectId)
                    params.append("project_id", "" + projectId);
                return [2 /*return*/, this.highway.get("vehicles/flat?" + params.toString())];
            });
        }); };
        /**
         * Create a new route from a vehicle object.
         */
        this.fromRoute = function (route) {
            var end_location = route.end_location, start_location = route.start_location, max_volume = route.max_volume, max_weight = route.max_weight, max_services = route.max_services, provides = route.provides, timewindow = route.timewindow, plate = route.plate, vehicle_model = route.vehicle_model, icon = route.icon, brand = route.brand, phone = route.phone, label = route.label, email = route.email, custom_fields = route.custom_fields, price_per_minute = route.price_per_minute, price_per_distance = route.price_per_distance;
            var newVehicle = {
                default_start_location: start_location,
                default_end_location: end_location,
                default_max_volume: max_volume,
                default_max_weight: max_weight,
                default_max_services: max_services,
                default_provides: provides,
                default_timewindow: timewindow,
                plate: plate,
                vehicle_model: vehicle_model,
                icon: icon,
                brand: brand,
                phone: phone,
                label: label,
                email: email,
                custom_fields: custom_fields,
                price_per_minute: price_per_minute,
                price_per_distance: price_per_distance,
            };
            return Object.entries(newVehicle).reduce(function (a, _a) {
                var _b;
                var k = _a[0], v = _a[1];
                return (v === undefined ? a : __assign(__assign({}, a), (_b = {}, _b[k] = v, _b)));
            }, {});
        };
        this.highway = hw;
    }
    return Vehicle;
}());
exports.Vehicle = Vehicle;
//# sourceMappingURL=Vehicle.js.map